











































import {Component, Prop, Vue} from 'vue-property-decorator'
import {CombinedPlan} from "@/util/subscription";

@Component
export default class PricingTableLanding extends Vue {

    @Prop({
        default: false
    })
    centerContent!: boolean;


    @Prop()
    basicPlan!: CombinedPlan

    @Prop()
    proPlan!: CombinedPlan


    @Prop()
    premiumPlan!: CombinedPlan

    private activePricingOption: 'monthly' | 'yearly' = 'monthly';
}
